import React, { CSSProperties } from 'react';
import styled from '@emotion/styled';

const StyledPageHeading = styled.h1`
  padding: 0;
  font-size: 28px;
  line-height: 28px;
  font-weight: 600;
`;

const StyledPageSubHeading = styled.h2`
  padding: 0;
  font-size: 20px;
  font-weight: 600;
`;

export const PatientPageHeading = ({ children, style }: { children: React.ReactNode; style?: CSSProperties }) => (
  <StyledPageHeading style={style}>{children}</StyledPageHeading>
);

export const PatientPageSubHeading = ({ children, style }: { children: React.ReactNode; style?: CSSProperties }) => (
  <StyledPageSubHeading style={style}>{children}</StyledPageSubHeading>
);
